// extracted by mini-css-extract-plugin
export default {"errorContainer":"error_errorContainer__bc2i5","errorImg":"error_errorImg__9OYny"};